import IResourceGroup from '@/types/IResourceGroup';
import {
	Box,
	Button,
	FormControl,
	FormHelperText,
	FormLabel,
	Heading,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Text,
} from '@chakra-ui/react';
import Select from 'react-select';
import { useAddMemberToGroupModal } from './add-participant.controller';

interface IProps {
	resourceGroup: IResourceGroup;
	isOpen: boolean;
	close: () => void;
}

export default function AddParticipantModal(props: IProps) {
	const { availabilitiesQuery, form, handleSubmit, t } = useAddMemberToGroupModal(props);

	if (!availabilitiesQuery.data) {
		return null;
	}

	const options = availabilitiesQuery.data.resources.map((res) => ({
		label: `${res.name} - ${res.owner.email}`,
		value: res.id,
	}));

	return (
		<>
			<Modal isOpen={props.isOpen} onClose={props.close} size="2xl" isCentered>
				<ModalOverlay />
				<ModalContent>
					<ModalHeader>
						<Heading size="lg">{t('Add availability to the group')}</Heading>
					</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<Box mb={4}>
							<Text>{t('...')}</Text>
						</Box>
						<Box as="form" id="form-add-participant" onSubmit={handleSubmit}>
							<FormControl id="email">
								<FormLabel>{t('Availability')}</FormLabel>
								<Select
									autoFocus
									required
									value={{ label: form.watch('email').label, value: form.watch('email').value }}
									onChange={(e) => {
										form.setValue(
											'email',
											{ label: e?.label || '', value: e?.value || '' },
											{ shouldDirty: true, shouldTouch: true, shouldValidate: true }
										);
									}}
									options={options}
									isClearable
								/>
								<FormHelperText>{t('Name of the availability - email of the owner')}</FormHelperText>
							</FormControl>
						</Box>
					</ModalBody>

					<ModalFooter>
						<Button variant="ghost" mr={3} onClick={props.close}>
							{t('Close')}
						</Button>
						<Button
							form="form-add-participant"
							isDisabled={!form.formState.isValid}
							isLoading={form.formState.isSubmitting}
							colorScheme="primary"
							type="submit"
						>
							{t('Add users')}
						</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>
		</>
	);
}
